import { render } from "./SignOut.vue?vue&type=template&id=0b5b0651&scoped=true"
import script from "./SignOut.vue?vue&type=script&lang=js"
export * from "./SignOut.vue?vue&type=script&lang=js"

import "./SignOut.vue?vue&type=style&index=0&id=0b5b0651&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5b0651"]])

export default __exports__